import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import * as React from "react";
import TitleCustom from "components/CustomTitle";
import { useState } from "react";
import EditCompany from "./editCompanies";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "examples/Tables/DataTable";
import getTableData from "./formatTableData";
import { useCallback } from "react";
import { useEffect } from "react";
import { companies } from "rest/requests";
import { getExcelData } from "./getExcelData";

function Companies() {
  const [companiesList, setCompanyList] = useState([]);
  const [companyToEdit, setCompanyToEdit] = useState(null);
  const [isEditingCompany, setIsEditingCompany] = useState(false);

  const getCompanyData = useCallback(async () => {
    setCompanyList(await companies());
  }, [isEditingCompany]);

  useEffect(() => {
    getCompanyData();
  }, [isEditingCompany]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isEditingCompany ? (
        <EditCompany companyToEdit={companyToEdit} setIsEditingCompany={setIsEditingCompany} />
      ) : (
        <div>
          <TitleCustom
            title={"Administración Empresas"}
            excelData={getExcelData(companiesList)}
            excelName={"Empresas.xlsx"}
          ></TitleCustom>

          <MDButton
            variant="text"
            size="small"
            color="secondary"
            onClick={() => {
              setCompanyToEdit(null);
              setIsEditingCompany(true);
            }}
          >
            <AddIcon></AddIcon>
            Adicionar Empresa
          </MDButton>

          <br></br>
          <DataTable
            table={getTableData(companiesList, setIsEditingCompany, setCompanyToEdit)}
            canSearch={true}
          />
        </div>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Companies;
